import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Menu from '../../components/sturtural/Menu';
import { BASE_API } from '../../api/Globals';
import { helpHttp } from '../../helpers/helpHttp';
import DocumentValidationCard from '../../components/demand/DocumentValidationCard';
import Loader from '../../components/sturtural/Loader';
import MessageDetail from '../../components/sturtural/MessageDetail';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import DocumentFormValidation from '../../components/demand/DocumentFormValidation';
import HeaderFinaliceValidation from '../../components/demand/HeaderFinaliceValidation';
import { storage } from '../../helpers/storage';

const ValidationDocuments = () => {
    const [db, setDb] = useState(null); 
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [displayBasic, setDisplayBasic] = useState(false);
    const [adjuntoid, setAdjuntoId] = useState(false);
    const [urlpdf, setUrlpdf] = useState(false);

    const [mesaje, setMesaje] = useState(false);
    const [documento, setDocumento] = useState(false);

    const [response, setResponse] = useState(false);

    const [finalice, setFinalice] = useState(false);

    const navigate = useNavigate();


    
    let url = `${BASE_API}demand/attachments/${window.localStorage.getItem('solicitudid')}`;

    useEffect(() => {
        setLoading(true);
        helpHttp().get(url).then(res => {
            if(!res.err) {
                setDb(res.attachments);
                setError(null);
            } else {
                setDb(null);
                setError(res);
            }
            setLoading(false);
        });
    }, [url]);

    const handleHidden = () => {
        setDisplayBasic(false);
    }

    const handleDialogValidation = (_adjuntoid, urlpdf, documento) =>{
        setAdjuntoId(_adjuntoid);
        setUrlpdf(urlpdf);
        setDisplayBasic(true);
        setDocumento(documento);
    }

    const handlerEdit = (data) => {

        let newData = db.map((el) => 
            (el.tipodocumentoid === data.tipodocumentoid ? data : el)
        );

        setDb(newData);
    }

    const handlerAviso = (message) => {
        setResponse(true);
        setMesaje(message);
    }

    const handlerRedirect = () => {
        navigate("/lista-solicitudes-validacion");
    }

    const basicDialogFooter = <Button type="button" label="Aceptar" onClick={handlerRedirect} icon="pi pi-check" className="p-button-secondary" />;

    return (
        <>
            <Menu link='documentos' />

            <HeaderFinaliceValidation 
                solicitud={window.localStorage.getItem('solicitudid')} 
                finalice={finalice} 
                title="EVALUACIÓN DE DOCUMENTOS DIGITALIZADOS"
            />

            <div className="grid">
                {loading && <Loader />}
                {error && <MessageDetail color="error" mensaje={`Error ${error.status}: ${error.statusText}`} />}
                {db &&  <DocumentValidationCard data={db} handleDialogValidation={handleDialogValidation} />}
                {db &&  <Dialog header="Valida documento" visible={displayBasic} style={{ width: '60vw' }} modal className="p-fluid" onHide={() => setDisplayBasic(false)}>
                            <DocumentFormValidation adjuntoid={adjuntoid} url={urlpdf} handleHidden={handleHidden} handlerEdit={handlerEdit} handlerAviso={handlerAviso} documento={documento} />
                        </Dialog>}
            </div>

            <Dialog header="Aviso" visible={response} style={{ width: '30vw' }} modal footer={basicDialogFooter} onHide={() => setDisplayBasic(false)}>
                <p>{mesaje}</p>
            </Dialog>
        </>
    );
}

export default ValidationDocuments;